// Image that swaps to a fallback source, then to an icon, when it fails to load (<x-img>).
// Registered once here instead of inlined into every image's x-data.
const imgFallback = (src, fallbackSrc) => ({
    currentSrc: src || fallbackSrc,
    fallbackSrc,
    fallbackUsed: !src && !!fallbackSrc,
    imageError: !(src || fallbackSrc),
    useFallback() {
        if (!this.fallbackUsed && this.fallbackSrc && this.currentSrc !== this.fallbackSrc) {
            this.fallbackUsed = true;
            this.currentSrc = this.fallbackSrc;
            this.imageError = false;
            return;
        }

        this.imageError = true;
    },
    verifyImage(el) {
        if (!this.currentSrc || (el.complete && el.naturalWidth === 0)) {
            this.useFallback();
            return;
        }

        this.imageError = false;
    },
});

export default imgFallback;
